import { render, staticRenderFns } from "./loginAsProvider.vue?vue&type=template&id=afba7dd4&scoped=true&"
import script from "./loginAsProvider.vue?vue&type=script&lang=babel&"
export * from "./loginAsProvider.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afba7dd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
